<template>
  <div>
    <a-upload
      name="avatar"
      :show-upload-list="false"
      :customRequest="uploadImg"
      :before-upload="beforeUpload"
      @change="handleChange"
      accept=".srt">
      <div>
        <a-button> <a-icon :type="loading ? 'loading' : 'upload'" />点击上传</a-button>
      </div>
    </a-upload>
    <!-- <div v-if="content">
      <a-textarea disabled auto-size v-model="content"/>
    </div> -->
  </div>
</template>
<script>
function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
}
const OSS = require('ali-oss')
import OssApi from '../api/src/oss/api/OssApi'
const ossApi = new OssApi()
export default {
  name: 'FileContentUpload',
  data() {
    return {
      loading: false,
      content: '',
      checked: false
    };
  },
  methods: {
    handleChange(info) {
      if (info.file.status === 'uploading') {
        this.loading = true;
        return;
      }
      // if (info.file.status === 'done') {
      //   // Get this url from response in real world.
      //   getBase64(info.file.originFileObj, imageUrl => {
      //     this.imageUrl = imageUrl;
      //     this.loading = false;
      //   });
      // }
    },
    async beforeUpload(file) {
      console.log(file.type)
      const isJpgOrPng = file.name.includes('.srt');
      if (!isJpgOrPng) {
        this.$message.error('只能上传 srt 文件!');
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('文件必须小于 2MB!');
      }
      return isJpgOrPng && isLt2M;
    },
    async uploadImg(info) {
      console.log(info)
      var fileReader = new FileReader()
      fileReader.onload = (e) => {
        this.content = e.target.result
        this.$emit('changeContent', e.target.result)
        this.loading = false
      }
      fileReader.readAsText(info.file)
    },
  },
};
</script>
<style>
.avatar-uploader > .ant-upload {
  width: 128px;
  height: 128px;
}
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
</style>